@if (isRecording()) {
  @if (useStreaming) {
    <div
      class="waveform-indicator"
      role="button"
      tabindex="0"
      aria-label="Stop transcription"
      matTooltip="{{ 'INBOX.UPLOAD_FILE.VOICE_TRANSCRIPTION.STOP_TRANSCRIPTION' | translate }}"
      (click)="toggleTranscription()"
      (keydown.enter)="toggleTranscription()"
      (keydown.space)="toggleTranscription()"
    >
      @for (h of waveform.barHeights(); track $index) {
        <span class="waveform-bar" [style.height.px]="h"></span>
      }
    </div>
  } @else {
    <div
      class="batch-indicator"
      role="button"
      tabindex="0"
      aria-label="Stop transcription"
      matTooltip="{{ 'INBOX.UPLOAD_FILE.VOICE_TRANSCRIPTION.STOP_TRANSCRIPTION' | translate }}"
      (click)="toggleTranscription()"
      (keydown.enter)="toggleTranscription()"
      (keydown.space)="toggleTranscription()"
    >
      <span class="recording-dot"></span>
      <span class="countdown">{{ remainingFormattedTime() }}</span>
    </div>
  }
} @else if (isFlushing()) {
  <div class="waveform-indicator waveform-indicator--flushing" aria-label="Finishing transcription">
    <glxy-loading-spinner [inline]="true" size="small" [fullWidth]="false"></glxy-loading-spinner>
  </div>
} @else {
  <button
    mat-icon-button
    aria-label="Start voice transcription"
    matTooltip="{{ 'INBOX.UPLOAD_FILE.VOICE_TRANSCRIPTION.TITLE' | translate }}"
    [disabled]="disabled || isProcessing"
    (click)="toggleTranscription()"
  >
    @if (isProcessing) {
      <glxy-loading-spinner [inline]="true" size="small" [fullWidth]="false"></glxy-loading-spinner>
    } @else {
      <mat-icon [inline]="true">graphic_eq</mat-icon>
    }
  </button>
}
